import { Slider } from '@mui/material';
import { type Props } from './types.ts';

export const RangeSlider = ({
  ariaLabelledBy,
  calculateScale,
  disabled,
  formatAriaValueText,
  formatValueLabel,
  getAriaLabel,
  marks,
  max,
  min,
  name,
  onChange,
  step,
  sx,
  value,
  valueLabelDisplay,
}: Props) => (
  <Slider
    aria-labelledby={ariaLabelledBy}
    disableSwap
    disabled={disabled}
    getAriaLabel={getAriaLabel}
    getAriaValueText={formatAriaValueText}
    marks={marks}
    max={max}
    min={min}
    name={name}
    onChange={onChange}
    scale={calculateScale}
    step={step}
    sx={sx}
    value={value}
    valueLabelDisplay={valueLabelDisplay}
    valueLabelFormat={formatValueLabel}
  />
);
